import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'i2a-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() public headerStyle: any;
  public useBackgroundImage:Boolean;
  public test: SafeStyle;
  constructor(
    private sanitizer: DomSanitizer
    ) {
    this.useBackgroundImage = true;
  }

  ngOnInit(): void {
    if (this.headerStyle != null)
    {
      this.useBackgroundImage = false;
      this.test = this.headerStyle;
    } else {
      this.test = this.sanitizer.bypassSecurityTrustStyle("--color: #2B3146;--colorHover:#9c9364");
    }
  }

  ngOnDestroy(): void {
  }

}
